var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "stats-container", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stats-card" }, [
                _c("div", { staticClass: "stats-content" }, [
                  _c("i", { staticClass: "el-icon-document stats-icon" }),
                  _c("div", [
                    _c("div", { staticClass: "stats-value" }, [
                      _vm._v(_vm._s(_vm.statistics.totalContracts)),
                    ]),
                    _c("div", { staticClass: "stats-label" }, [
                      _vm._v("Total Contracts"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stats-card" }, [
                _c("div", { staticClass: "stats-content" }, [
                  _c("i", { staticClass: "el-icon-check stats-icon active" }),
                  _c("div", [
                    _c("div", { staticClass: "stats-value" }, [
                      _vm._v(_vm._s(_vm.statistics.activeContracts)),
                    ]),
                    _c("div", { staticClass: "stats-label" }, [
                      _vm._v("Active Versions"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stats-card" }, [
                _c("div", { staticClass: "stats-content" }, [
                  _c("i", { staticClass: "el-icon-user stats-icon users" }),
                  _c("div", [
                    _c("div", { staticClass: "stats-value" }, [
                      _vm._v(_vm._s(_vm.statistics.totalAcceptances)),
                    ]),
                    _c("div", { staticClass: "stats-label" }, [
                      _vm._v("Total Acceptances"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stats-card" }, [
                _c("div", { staticClass: "stats-content" }, [
                  _c("i", { staticClass: "el-icon-s-data stats-icon" }),
                  _c("div", [
                    _c("div", { staticClass: "stats-value" }, [
                      _vm._v(_vm._s(_vm.uniqueContractNames)),
                    ]),
                    _c("div", { staticClass: "stats-label" }, [
                      _vm._v("Contract Types"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "20px", "margin-bottom": "20px" },
          attrs: { gutter: 20 },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c("el-input", {
                staticStyle: { width: "250px", "margin-right": "10px" },
                attrs: {
                  placeholder: "Filter by contract name",
                  clearable: "",
                },
                on: { clear: _vm.handleFilter },
                model: {
                  value: _vm.listQuery.contractName,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "contractName", $$v)
                  },
                  expression: "listQuery.contractName",
                },
              }),
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px", "margin-right": "10px" },
                  attrs: { placeholder: "Filter by status", clearable: "" },
                  on: { change: _vm.handleFilter },
                  model: {
                    value: _vm.listQuery.isActive,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "isActive", $$v)
                    },
                    expression: "listQuery.isActive",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "All", value: null } }),
                  _c("el-option", {
                    attrs: { label: "Active Only", value: true },
                  }),
                  _c("el-option", {
                    attrs: { label: "Inactive Only", value: false },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v(" Filter ")]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 8 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleCreate },
                },
                [_vm._v(" New Contract Version ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading...",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "ID", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.id) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Contract Name", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "primary" } }, [
                      _vm._v(_vm._s(row.contractName)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Version", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("strong", [_vm._v(_vm._s(row.version))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: row.isActive ? "success" : "info" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(row.isActive ? "Active" : "Inactive") +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Localization Key", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("code", [_vm._v(_vm._s(row.localizationKey))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Description", align: "left", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.description || "-") + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Acceptances", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "warning" } }, [
                      _vm._v(_vm._s(row.acceptanceCount || 0)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Created At", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("formatDate")(row.createdAt)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              align: "center",
              width: "250",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewDetails(row)
                          },
                        },
                      },
                      [_vm._v(" View ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: row.isActive ? "warning" : "success",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleToggle(row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(row.isActive ? "Deactivate" : "Activate") +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "danger",
                          disabled: row.acceptanceCount > 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v(" Delete ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogStatus === "create"
                ? "Create New Contract Version"
                : "Update Contract",
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                rules: _vm.rules,
                model: _vm.tempContractData,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Contract Name", prop: "contractName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., consult, zoom, privacy_policy",
                      disabled: _vm.dialogStatus === "update",
                    },
                    model: {
                      value: _vm.tempContractData.contractName,
                      callback: function ($$v) {
                        _vm.$set(_vm.tempContractData, "contractName", $$v)
                      },
                      expression: "tempContractData.contractName",
                    },
                  }),
                  _c("span", { staticClass: "form-hint" }, [
                    _vm._v(
                      " Contract identifier (cannot be changed after creation) "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Version", prop: "version" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., 1, 2, 20251117",
                      disabled: _vm.dialogStatus === "update",
                    },
                    model: {
                      value: _vm.tempContractData.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.tempContractData, "version", $$v)
                      },
                      expression: "tempContractData.version",
                    },
                  }),
                  _c("span", { staticClass: "form-hint" }, [
                    _vm._v(
                      " Version identifier (cannot be changed after creation) "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Localization Key", prop: "localizationKey" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "e.g., contract.consult" },
                    model: {
                      value: _vm.tempContractData.localizationKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.tempContractData, "localizationKey", $$v)
                      },
                      expression: "tempContractData.localizationKey",
                    },
                  }),
                  _c("span", { staticClass: "form-hint" }, [
                    _vm._v(" i18n key for fetching contract text "),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Optional description for admin reference",
                    },
                    model: {
                      value: _vm.tempContractData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.tempContractData, "description", $$v)
                      },
                      expression: "tempContractData.description",
                    },
                  }),
                ],
                1
              ),
              _vm.dialogStatus === "create"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Auto-Deactivate Old Versions" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-text": "Yes", "inactive-text": "No" },
                        model: {
                          value: _vm.tempContractData.deactivateOldVersions,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tempContractData,
                              "deactivateOldVersions",
                              $$v
                            )
                          },
                          expression: "tempContractData.deactivateOldVersions",
                        },
                      }),
                      _c("div", { staticClass: "form-hint" }, [
                        _vm._v(
                          " Automatically set other versions of this contract to inactive "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogStatus === "create"
                        ? _vm.createData()
                        : _vm.updateData()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dialogStatus === "create" ? "Create" : "Update"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Contract Details",
            visible: _vm.dialogDetailsVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDetailsVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 1, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                _vm._v(_vm._s(_vm.selectedContract.id)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Contract Name" } },
                [
                  _c("el-tag", { attrs: { type: "primary" } }, [
                    _vm._v(_vm._s(_vm.selectedContract.contractName)),
                  ]),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "Version" } }, [
                _c("strong", [_vm._v(_vm._s(_vm.selectedContract.version))]),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Status" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.selectedContract.isActive
                          ? "success"
                          : "info",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedContract.isActive
                              ? "Active"
                              : "Inactive"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Localization Key" } },
                [
                  _c("code", [
                    _vm._v(_vm._s(_vm.selectedContract.localizationKey)),
                  ]),
                ]
              ),
              _c("el-descriptions-item", { attrs: { label: "Description" } }, [
                _vm._v(
                  " " + _vm._s(_vm.selectedContract.description || "-") + " "
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "User Acceptances" } },
                [
                  _c("el-tag", { attrs: { type: "warning" } }, [
                    _vm._v(_vm._s(_vm.selectedContract.acceptanceCount || 0)),
                  ]),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "Created At" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatDate")(_vm.selectedContract.createdAt)
                    ) +
                    " "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "Updated At" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatDate")(_vm.selectedContract.updatedAt)
                    ) +
                    " "
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogDetailsVisible = false
                    },
                  },
                },
                [_vm._v(" Close ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }